import { useEffect, useState } from "react";

export function useClientReady() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    if (!window.__TB_PRERENDER_CAPTURE__) setReady(true);
  }, []);
  return ready;
}